var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    id: "svg15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient828"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff0000",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop826"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: 0,
    gradientUnits: "userSpaceOnUse",
    y1: 47.37,
    x2: 0,
    y2: -1.429
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c52828",
    id: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5454",
    id: "stop4"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99999 0 0 .99999-58.37.882)",
    id: "g13"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82.37,
    cy: 23.12,
    r: 24,
    fill: "url(#0)",
    id: "circle9",
    style: {
      fillOpacity: 1,
      fill: "#dd3333"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m87.77 23.725l5.939-5.939c.377-.372.566-.835.566-1.373 0-.54-.189-.997-.566-1.374l-2.747-2.747c-.377-.372-.835-.564-1.373-.564-.539 0-.997.186-1.374.564l-5.939 5.939-5.939-5.939c-.377-.372-.835-.564-1.374-.564-.539 0-.997.186-1.374.564l-2.748 2.747c-.377.378-.566.835-.566 1.374 0 .54.188.997.566 1.373l5.939 5.939-5.939 5.94c-.377.372-.566.835-.566 1.373 0 .54.188.997.566 1.373l2.748 2.747c.377.378.835.564 1.374.564.539 0 .997-.186 1.374-.564l5.939-5.939 5.94 5.939c.377.378.835.564 1.374.564.539 0 .997-.186 1.373-.564l2.747-2.747c.377-.372.566-.835.566-1.373 0-.54-.188-.997-.566-1.373l-5.939-5.94",
    fill: "#fff",
    id: "path11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRedCircle);
export default __webpack_public_path__ + "static/media/Cross_red_circle.3f1bdba02221e28e145bf90924abf984.svg";
export { ForwardRef as ReactComponent };